import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-confomer',
  standalone: true,
  imports: [],
  templateUrl: './confomer.component.html',
  styleUrl: './confomer.component.css',
})
export class ConfomerComponent {
  @Input() type: 'delete' | 'update' | 'create' = 'delete';
  @Input() title = 'Confirm';
  @Input() message = 'Are you sure?';
  @Output() confirm = new EventEmitter<boolean>();

  modelInputCheck = false;

  public open(): void {
    this.modelInputCheck = true;
  }

  onConfirm() {
    this.modelInputCheck = false;
    this.confirm.emit(true);
  }

  onCancel() {
    this.modelInputCheck = false;
    this.confirm.emit(false);
  }
}
